import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getCentrosCustosFilhos({ commit }, codCCustoPai) {
      try {
        const response = await api.get(`/centros-custos/${codCCustoPai}/filhos`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getResumoCentrosCustosFilhos({ commit }, data) {
      try {
        const response = await api.get(
          `/centros-custos/${data.codCCustoPai}/filhos/orcamento/${data.orcamentoId}?exibirCentrosCustoBloqueado=${data.exibirCentrosCustoBloqueado}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getDetalhesCentroCustoFilho({ commit }, data) {
      try {
        const response = await api.get(
          `/centros-custos/${data.codCCustoPai}/filhos/orcamento/${data.orcamentoId}/${data.codCCustoFilho}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
